import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi, getActiveAgent, setActiveAgent } from "./api";

const AuthContext = createContext(null);

// Ensure the selected agent is always one the user is allowed to work on.
function reconcileAgent(adm) {
    const access = adm?.agent_access || [];
    if (access.length && !access.includes(getActiveAgent())) {
        setActiveAgent(access[0]);
    }
}

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null = checking, false = unauth, object = authed
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("orchid_admin_token");
        if (!token) {
            setAdmin(false);
            setLoading(false);
            return;
        }
        adminApi
            .get("/api/admin/me")
            .then((r) => {
                reconcileAgent(r.data);
                setAdmin(r.data);
            })
            .catch(() => setAdmin(false))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await adminApi.post("/api/admin/login", { email, password });
        localStorage.setItem("orchid_admin_token", data.access_token);
        reconcileAgent(data.admin);
        setAdmin(data.admin);
        return data.admin;
    };

    const logout = () => {
        localStorage.removeItem("orchid_admin_token");
        setAdmin(false);
        window.location.assign("/login");
    };

    return (
        <AuthContext.Provider value={{ admin, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
